// Main exports of the Unify Browser global
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
export * from 'src';
export { cssCustomPropertyPrefix } from '@workiva/unify-tokens-raw';
export { makeTransparent } from '@workiva/unify-tokens';
export { defaultCssVarPrefix as muiThemeCssVarPrefix } from 'src/styles/themes/constants';
export { createMaterialSymbolsIcon } from 'src/components/MaterialSymbolsIcon/createMaterialSymbolsIcon';
export { createCustomUnifyIcon } from 'src/components/UnifyIcons/CustomUnifyIcon/createCustomUnifyIcon';
export { default as buttonClasses } from 'src/wsd/components/Button/buttonClasses';
export {
  DisabledAncestorProvider,
  useIsAncestorDisabled,
} from 'src/context/DisabledAncestorContext/DisabledAncestorContext';
export * from 'src/localization/localizedDayjs';

// Keep WsdAlert in the bundle to support the deprecated WsdAlert Dart component.
export {
  /* eslint-disable-next-line deprecation/deprecation */
  WsdAlert,
  /* eslint-disable-next-line deprecation/deprecation */
  type WsdAlertProps,
} from 'src/wsd/components/WsdAlert/WsdAlert';

// Re-export Unify-prefixed components as their non-prefixed names. These non-prefixed names are no
// longer used anywhere since react_material_ui was deleted, so we can change them over to the Unify
// versions. Once these have baked in the JS bundle for a while, we can remove the Unify-prefixed
// un_wsd_components.tsx and simply export the non-prefixed components from components.dart.ts like
// all other components.
export {
  UnifyAlert as Alert,
  type UnifyAlertProps as AlertProps,
  UnifyBadge as Badge,
  type UnifyBadgeProps as BadgeProps,
  UnifyLinearProgress as LinearProgress,
  type UnifyLinearProgressProps as LinearProgressProps,
} from 'src/un_wsd_components';

export {
  // Name this as `MaterialSymbolsIcon` so that we generate a Dart MaterialSymbolsIconProps for it
  DummyMaterialSymbolsIcon as MaterialSymbolsIcon,
  type MaterialSymbolsIconProps,
} from 'src/components/MaterialSymbolsIcon/MaterialSymbolsIcon';
export {
  // Name this as `CustomUnifyIcon` so that we generate a Dart CustomUnifyIconProps for it
  DummyCustomUnifyIcon as CustomUnifyIcon,
  type CustomUnifyIconProps,
} from 'src/components/UnifyIcons/CustomUnifyIcon/CustomUnifyIcon';
export {
  // Name this as `UnifyIcon` so that we generate a Dart UnifyIconProps for it
  DummyUnifyIcon as UnifyIcon,
  type UnifyIconProps,
} from 'src/components/UnifyIcons/UnifyIcons';

export * from 'src/eap/components/WorkivaAssistant';

// Generate these Wsd-prefixed components for the package rename migration.
export {
  WsdLinkButton,
  type WsdLinkButtonProps,
} from 'src/wsd/components/WsdLinkButton/WsdLinkButton';

export * from 'src/un_wsd_components';
export { GroupedVirtuoso, Virtuoso } from 'react-virtuoso';

/**
 * Loads the UnifyUI DateRangePicker js bundle and its dependencies asynchronously.
 *
 * Calling this function is not required to render {@link DateRangePicker} since it is a
 * `React.lazy` component that will load the bundle right before the component is
 * rendered.
 *
 * This function allows consumers to optionally load the DateRangePicker
 * bundle earlier in the background before {@link DateRangePicker} is called. Doing this
 * might reduce the time the fallback UI in {@link React.Suspense} is rendered while
 * waiting for the bundle to be loaded before rendering {@link DateRangePicker}.
 */
export async function loadDatePickers(): Promise<
  typeof import('./browser.date_pickers')
> {
  return await import('./browser.date_pickers');
}

/**
 * Loads the UnifyUI DataGridPro js bundle and its dependencies asynchronously.
 *
 * Calling this function is not required to render {@link DataGridPro} since it is a
 * `React.lazy` component that will load the bundle right before the component is
 * rendered.
 *
 * This function allows consumers to optionally load the DataGridPro
 * bundle earlier in the background before {@link DataGridPro} is called. Doing this
 * might reduce the time the fallback UI in {@link React.Suspense} is rendered while
 * waiting for the bundle to be loaded before rendering {@link DataGridPro}.
 */
export async function loadDataGridPro(): Promise<typeof import('./browser.data_grid_pro')> {
  return await import('./browser.data_grid_pro');
}

/**
 * Loads the UnifyUI DataGridPremium js bundle and its dependencies asynchronously.
 *
 * Calling this function is not required to render {@link DataGridPremium} since it is a
 * `React.lazy` component that will load the bundle right before the component is
 * rendered.
 *
 * This function allows consumers to optionally load the DataGridPremium
 * bundle earlier in the background before {@link DataGridPremium} is called. Doing this
 * might reduce the time the fallback UI in {@link React.Suspense} is rendered while
 * waiting for the bundle to be loaded before rendering {@link DataGridPremium}.
 */
export async function loadDataGridPremium(): Promise<
  typeof import('./browser.data_grid_premium')
> {
  return await import('./browser.data_grid_premium');
}

// Using alias because the "Lazy" name is only meant to differentiate it from the real component that it loads.
export {
  /** displayName=DataGridPro */ DataGridProLazy as DataGridProV7,
} from 'src/components/DataGridPro/DataGridProLazy';
export { DataGridPremiumLazy as DataGridPremium } from 'src/components/DataGridPremium/DataGridPremiumLazy';
export { GridToolbarLazy as GridToolbar } from 'src/components/DataGridShared/GridToolbar/GridToolbarLazy';

// Expose notification components to JS bundle for Dart since they aren't exposed in src since the TS entrypoint is split out.
export * from './index.node.banner';
export * from './index.node.toast';
